import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    fieldItem: {
      display: 'grid',
      gridTemplateColumns: '220px 60px 50px 15px',
      gap: '12px',
      alignItems: 'center',
      transition: 'all 0.3s ease',
      '& .MuiCheckbox-root': {
        color: '#646464',
        '&.Mui-checked': {
          color: theme.palette.primary.dark,
        },
      },
    },
    fieldName: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 600,
      minWidth: '100px',
      overflow: 'hidden',
      textAlign: 'left',
    },
    fieldNameText: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      width: '100%',
      textAlign: 'left',
    },
    areaTag: {
      fontSize: '11px',
      color: '#001D29',
      fontWeight: 600,
      borderRadius: '5px',
      backgroundColor: '#F0F0F0',
      padding: '1px 8px',
      textAlign: 'center',
    },
    diagnosisTag: {
      fontSize: '11px',
      color: '#001D29',
      fontWeight: 600,
      borderRadius: '5px',
      border: '1px solid #DDDDDD',
      padding: '1px 8px',
      textAlign: 'center',
    },
    iconContainer: {
      textAlign: 'center',
      '& svg': {
        fontSize: '16px',
      },
    },
  }),
)
